/*  */

/* Vue 富文本编辑器 */
import { quillEditor } from "vue-quill-editor";

// 富文本编辑器样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import Editor from "./Editor/index.vue";

import StatusText from "./StatusText/index.vue";

export default {
  install: (app) => {
    app.component("quillEditor", quillEditor);

    app.component("Editor", Editor);

    app.component("StatusText", StatusText);
  },
};
